export const DATA_LAMPS = 'data/lamps'
